var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.9V16.5H9.9V9.9H16.5ZM19.8 6.6H6.6V19.8H19.8V6.6ZM16.5 27.5V34.1H9.9V27.5H16.5ZM19.8 24.2H6.6V37.4H19.8V24.2ZM34.1 9.9V16.5H27.5V9.9H34.1ZM37.4 6.6H24.2V19.8H37.4V6.6ZM24.2 24.2H27.5V27.5H24.2V24.2ZM27.5 27.5H30.8V30.8H27.5V27.5ZM30.8 24.2H34.1V27.5H30.8V24.2ZM24.2 30.8H27.5V34.1H24.2V30.8ZM27.5 34.1H30.8V37.4H27.5V34.1ZM30.8 30.8H34.1V34.1H30.8V30.8ZM34.1 27.5H37.4V30.8H34.1V27.5ZM34.1 34.1H37.4V37.4H34.1V34.1ZM44 11H39.6V4.4H33V0H44V11ZM44 44V33H39.6V39.6H33V44H44ZM0 44H11V39.6H4.4V33H0V44ZM0 0V11H4.4V4.4H11V0H0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanWhite);
export default __webpack_public_path__ + "static/media/scan-white.8aa266563fe68aaaaaba465b6d0afce6.svg";
export { ForwardRef as ReactComponent };